import React from "react";
import { Localization } from "@viamap/viamap2-common";
import { ADModalBody, ADModalFooter, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import jsPDF from "jspdf";
import { GlassButton, GlassButtonRow } from "src/components/GlassButtons";

const hints = ["attributes", "operators", "functions", "relations", "selectors", "cubes", "toCube empty values", "compatibility"];
const examples = ["arithmetic", "conditional", "round", "first value", "has value", "traversal", "deep traversal", "parent lookup", "dynamic attribute", "filtered traversal", "quoted names", "aggregate arguments", "parent aggregate", "filtered count", "parent fallback", "navigation", "cube slice", "cube summary", "cube selector", "cube total", "child cubes", "cube all dimensions", "cube arithmetic", "cube literal"];

function exportHelpPdf() {
   const pdf = new jsPDF({ unit: "mm", format: "a4" });
   const margin = 15;
   const width = pdf.internal.pageSize.getWidth() - margin * 2;
   const bottom = pdf.internal.pageSize.getHeight() - margin;
   let y = margin;
   const write = (text: string, size: number, bold: boolean, indent: number) => {
      pdf.setFont("helvetica", bold ? "bold" : "normal");
      pdf.setFontSize(size);
      const lineHeight = size * 0.5;
      for (const line of pdf.splitTextToSize(text, width - indent) as string[]) {
         if (y + lineHeight > bottom) { pdf.addPage(); y = margin; }
         pdf.text(line, margin + indent, y);
         y += lineHeight;
      }
      y += 1.5;
   };
   write(Localization.getText("Expression syntax help"), 16, true, 0);
   y += 2;
   hints.forEach((hint) => write(`\u2022 ${Localization.getText(`Expression syntax hint ${hint}`)}`, 10, false, 0));
   y += 3;
   write(Localization.getText("Examples"), 13, true, 0);
   examples.forEach((example) => write(`\u2022 ${Localization.getText(`Expression syntax example ${example}`)}`, 10, false, 3));
   pdf.save("expression-syntax-help.pdf");
}
export function PLAExpressionHelpDialog(props: { onClose: () => void }) {
   return (
      <AdvancedDragModal title={Localization.getText("Expression syntax help")} PosDefault={{ width: "760px", left: "50%", transform: "translateX(-50%)", top: "120px" }} onClose={props.onClose}>
         <ADModalBody>
            <ul>
               {hints.map((hint) => <li key={hint}>{Localization.getText(`Expression syntax hint ${hint}`)}</li>)}
               <li>
                  <strong>{Localization.getText("Examples")}</strong>
                  <ul>{examples.map((example) => <li key={example}>{Localization.getText(`Expression syntax example ${example}`)}</li>)}</ul>
               </li>
            </ul>
         </ADModalBody>
         <ADModalFooter>
            <GlassButtonRow adjust="end">
               <GlassButton onClick={exportHelpPdf}>{Localization.getText("Export PDF")}</GlassButton>
               <GlassButton onClick={props.onClose}>{Localization.getText("Close")}</GlassButton>
            </GlassButtonRow>
         </ADModalFooter>
      </AdvancedDragModal>
   );
}
